











// vue
import { Component, Vue } from 'vue-property-decorator'

// components layouts
import {
    MainLayout,
    AuthLayout
} from './index'

@Component({
  name: 'IndexApp',
  components: {
      AuthLayout,
      MainLayout
  }
})
export default class IndexApp extends Vue {
    get isPageLogin (): boolean {
        return this.$route?.name === 'login'
    }
}
